import React from "react";
import { Helmet } from "react-helmet-async";
import { SOCIAL_IMAGE } from "../lib/seo";

const TermsAndConditions = () => {
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      {/* See the note in PrivacyPolicy.jsx -- same gap, same fix. */}
      <Helmet>
        <title>Terms &amp; Conditions | Savorka Solar</title>
        <meta
          name="description"
          content="The terms and conditions governing your use of the Savorka Solar website and services."
        />
        <link
          rel="canonical"
          href="https://www.savorka.in/terms-and-conditions/"
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Terms &amp; Conditions | Savorka Solar" />
        <meta
          property="og:description"
          content="The terms and conditions governing your use of the Savorka Solar website and services."
        />
        <meta
          property="og:url"
          content="https://www.savorka.in/terms-and-conditions/"
        />
          <meta property="og:image" content={SOCIAL_IMAGE} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image" content={SOCIAL_IMAGE} />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">Terms &amp; Conditions</h1>

      <p className="text-gray-600 mb-4">
        Welcome to Savorka Solar. By accessing this website, you agree to comply
        with and be bound by the following terms and conditions of use.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Use of Website</h2>
      <p className="text-gray-600 mb-4">
        The content of the pages of this website is for general information and
        use only. It is subject to change without notice.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Intellectual Property</h2>
      <p className="text-gray-600 mb-4">
        All materials on this website including text, images, and logos are the
        property of Savorka Solar and may not be reproduced without permission.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Contact</h2>
      <p className="text-gray-600">
        If you have any questions about these Terms & Conditions, please contact
        us through our contact page.
      </p>
    </div>
  );
};

export default TermsAndConditions;